module.exports = __webpack_public_path__ + "img/icon04.38e28ae1.png";